<template>
  <keep-alive include="screenSwitcher">
    <router-view />
  </keep-alive>
</template>

<script>

export default {

}
</script>

<style>

</style>
